<template>
	<section v-if="props">

		<carousel :navigationEnabled="true" :navigationNextLabel="''" :navigationPrevLabel="''" :perPage="1" :paginationActiveColor="'#f58466'" :paginationColor="'#999999'" :navigationClickTargetSize="5" :paginationPadding="5" :paginationSize="14" v-in-viewport="{}">



			<template v-if="props.length" v-for="slide in props">



				<slide class="column-slider">
					<div class="row">
						<div class="inside">

							<div class="info">
								<h3>{{slide.headline.value}}</h3>
								 <div v-html="slide.text.value">
									</div>
							</div>

							<div class="image">
								<img :src="slide.image.value[0].url" :alt="slide.headline.value" />
							</div>

						</div>
					</div>
				</slide>
			</template>


		</carousel>
	</section>
</template>


<script>
  require('../assets/img/left.svg');
	require('../assets/img/right.svg');
	require('../assets/img/play-button-circle.png');

	import { Carousel, Slide } from 'vue-carousel';
	import commons from '../mixins/common.js';
	import Player from '@vimeo/player';

	export default{
		name:'Slider',
		props: ['props'],
		mixins:[commons],
		components:{
			Carousel,
			Slide
		},
		data(){
			return{

			}
		},
		methods: {

			handleSlideClick: function(dataset) {
				setTimeout(function(){
					let v = dataset.videoid;
					$('.play-button[data-video-id='+dataset.name+']').hide();
					const player = new Player(document.getElementById(v), {
				    id: dataset.name,
				    width: 640,
						autoplay: true
					});

				},200);
			},
		},

		mounted () {
			setTimeout(function(){

					$('.VueCarousel-dot-button,.VueCarousel-navigation-button').on('click', function(){
						$('iframe').each(function() {
						  this.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
						  this.contentWindow.postMessage('{"method":"pause","value":""}', '*');
						});
					})

			},200);

		}
	}
</script>



// WEBPACK FOOTER //
// slider-cases.vue?16ecd9e0